'use strict';
/* ==========================================================================
   levels/title.js — "It's All Greek (and Latin) to Me": the title, the ZINE COVER (DESIGN.md §2). The structure is
   lessons/narrator/levels/title.js (a photocopied cover stapled to the corkboard, ransom-letter title in the zine
   palette, a neon highlighter swipe, "issue #3" typed, Nia left and Ms. Park right rising in, ▶ Play → the map; on a
   phone held upright the controls go to the portrait dock, Dock.title).
   This lesson's own picture, drawn with the word kit (core-local/wordkit.js) from the model: on a cutting mat lies the
   strip "helicopter"; the scissors glide along it and snip it at helico | pter (Words.cuts), the pieces slide apart and
   show what each part means (Words.short), then the DECODED stamp lands. Pure in time (T, this.enteredAt).
   Levels.title.loading() draws the "warming up the copier…" screen while the boot tier loads (no textures yet).
   ========================================================================== */
(function () {
  const PLAY = { x: 960, y: 986 };
  const WORD = 'helicopter';
  const COVER_PAL = [['#141210', '#f7f5ef'], ['#f7f5ef', '#141210'], ['#fff04a', '#141210'], ['news', '#141210'], ['#ff6fbf', '#141210'], ['#141210', '#fff04a'], ['#72f06e', '#141210']];
  function titleLines(text) {
    const s = String(text).toUpperCase(), i = s.indexOf('(');
    if (i > 0) return [s.slice(0, i).trim(), s.slice(i).trim()];
    const words = s.split(/\s+/); const k = Math.ceil(words.length / 2);
    return [words.slice(0, k).join(' '), words.slice(k).join(' ')];
  }
  const fitSize = (line, seed, maxW, max) => { const w = ransom(line, -5000, -5000, 100, 1e9, { seed, palette: COVER_PAL }); return Math.min(max, (maxW / Math.max(1, w)) * 100); };

  /* the strip on the mat: scissors glide from gap 2 to the right cut, snip, the pieces part, the glosses type on */
  const TL = { mat: 1.0, glide: 1.5, snip: 2.5, stamp: 3.6 };
  function cover(t0) {
    const cut = Words.cuts(WORD)[0], n = Words.spell(WORD).length;
    const s = pop(T, t0 + TL.mat, 0.4, 1.8);
    if (s <= 0) return;
    g.save(); g.translate(960, 720); g.scale(s, s); g.translate(-960, -720);
    WK.mat(470, 570, 980, 290);
    const L = WK.layout(WORD, { x: 520, w: 880, cy: 700 }, { display: true, maxPitch: 84, maxH: 104 });
    const snipAt = t0 + TL.snip, st = T >= snipAt ? { made: [cut], cutT: { [cut]: snipAt } } : {};
    WK.drawStrip(L, st);
    // the scissors: glide (ease) from gap 2 to the cut, snip, then lift away
    const u = E.inOutSine(P(T, t0 + TL.glide, t0 + TL.snip - 0.15)), p = 2 + (cut - 2) * u;
    const gx = WK.gapX(L, Math.floor(p), st) + (WK.gapX(L, Math.min(n - 1, Math.floor(p) + 1), st) - WK.gapX(L, Math.floor(p), st)) * (p - Math.floor(p));
    const sn = T - snipAt, open = sn >= 0 && sn < 0.3 ? Math.abs(Math.cos(sn / 0.3 * Math.PI)) * 0.7 : 0.7;
    const lift = c01v((T - snipAt - 0.5) / 0.6);
    if (lift < 1) WK.drawScissors(gx, L.cy + L.th * 0.18 - 172 * 0.55 - lift * 80, { s: 0.55, open, alpha: 1 - lift });
    g.restore();
    const at = t0 + TL.stamp;
    if (T >= at) Zine.stamp((Game.lesson.completeCard && Game.lesson.completeCard.title) || 'DECODED', 1215, 485, { rot: -0.12, s: 0.7 * (1 + 1.2 * (1 - P(T, at, at + 0.12))) });
  }
  const c01v = x => Math.max(0, Math.min(1, x));

  class Title extends Scene {
    enter() { this.started = false; this.snipped = false; this.stamped = false; WK.load(); }
    go() {
      if (this.started) return;
      this.started = true;
      Audio.unlock();
      if (Game.MUSIC) Audio.music(Game.MUSIC, { gain: 0.3 });
      Game.replace(new Levels.map());
    }
    keyDown(k) { if (k === 'Enter' || k === ' ') this.go(); }
    update() {
      const t0 = this.enteredAt;
      if (!this.snipped && T >= t0 + TL.snip) { this.snipped = true; Audio.play(Audio.has('snip') ? 'snip' : 'tear', { gain: 0.6 }); }
      if (!this.stamped && T >= t0 + TL.stamp) { this.stamped = true; Audio.play('stamp', { gain: 0.7 }); }
    }
    draw() {
      UI.allLessons();
      const t = this.t, t0 = this.enteredAt, L = Game.lesson || {}, Zn = window.Zine;
      Zn.cork();
      const cs = pop(T, t0 + 0.05, 0.45, 1.6);
      Zn.page(960, 470, 1100, 840, { seed: 27, rot: -0.01, s: cs, staple: 'left', tape: 2, dark: 0.5 });
      if (cs >= 0.999) {
        Zn.type('ISSUE #3', 500, 108, 34, { t0: t0 + 0.3, cps: 24 });
        Zn.type('free · take one', 1420, 108, 30, { t0: t0 + 0.5, cps: 24, align: 'right', color: Zn.C.grey });
        const lines = titleLines(L.title || 'It\'s All Greek (and Latin) to Me');
        const sizes = lines.map((l, i) => fitSize(l, 501 + i, 900, 116));
        const y1 = 220, y2 = y1 + sizes[0] * 1.3;
        const w2 = ransom(lines[1] || '', -5000, -5000, sizes[1] || 100, 1e9, { seed: 502, palette: COVER_PAL });
        Zn.highlight(960 - w2 / 2 - 24, y2 + 6, w2 + 60, sizes[1] * 1.25, '#fff04a', { t0: t0 + 1.25, dur: 0.45, seed: 9, rot: -0.01 });
        lines.forEach((l, i) => ransom(l, 960, i ? y2 : y1, sizes[i], t0 + 0.4 + i * 0.45, { seed: 501 + i, palette: COVER_PAL }));
        Zn.type(L.subtitle || '', 960, y2 + sizes[1] * 1.15, 30, { t0: t0 + 1.5, cps: 40, align: 'center' });
        cover(t0);
      }
      const riseN = E.outBack(P(T, t0 + 0.5, t0 + 1.0), 1.4), riseP = E.outBack(P(T, t0 + 0.7, t0 + 1.2), 1.4);
      Puppet.draw('nia', 230, 1080 + (1 - riseN) * 600, 640, { facing: 1, t: T });
      Puppet.draw('park', 1690, 1080 + (1 - riseP) * 600, 720, { facing: -1, t: T });
      if (UI.docked()) { Dock.title({ onStart: () => this.go(), onContinue: () => this.go() }); return; }
      if (t > 1.4 && UI.button('play', '▶ Play', PLAY.x, PLAY.y, { w: 380, h: 116, color: '#fff04a', text: Zn.C.ink, font: "'Luckiest Guy'", size: 64, rot: -0.015 })) this.go();
      if (t > 2.4) hand(UI.hint('(or press Enter)', 'tap ▶ Play to start'), PLAY.x + 330 + (UI.tap(116) - 116) / 2, PLAY.y + 6, UI.text(34), t0 + 2.4, { color: 'rgba(20,18,16,0.75)', seed: 61, align: 'left' });
    }
  }
  Title.PLAY = PLAY;                         // tools/integration.js clicks it

  /* loading screen: no textures yet → plain photocopy grey, a copier light sweeping across */
  Title.loading = function () {
    g.fillStyle = '#e9e6de'; g.fillRect(0, 0, Game.W, Game.H);
    const u = (T * 0.6) % 1, x = 260 + u * 1400;
    const gr = g.createLinearGradient(x - 120, 0, x + 120, 0);
    gr.addColorStop(0, 'rgba(120,255,190,0)'); gr.addColorStop(0.5, 'rgba(120,255,190,0.55)'); gr.addColorStop(1, 'rgba(120,255,190,0)');
    g.fillStyle = gr; g.fillRect(x - 120, 360, 240, 360);
    g.strokeStyle = '#141210'; g.lineWidth = 6; g.strokeRect(260, 360, 1400, 360);
    g.save(); g.font = "64px 'Special Elite', 'Courier New', monospace"; g.textAlign = 'center'; g.textBaseline = 'middle'; g.fillStyle = '#141210';
    g.fillText('warming up the copier…', 960, 820); g.restore();
  };

  Levels.title = Title;
})();
